<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="h2"><span class="bold">Introduction</span></p>
<p class="noindent"><span class="drop-cap">I</span>n the aftermath of Alexander’s destruction of the Akhaimenid (Persian) Empire during his campaigns of 334–323, four families emerged to found dynasties who ruled sections of that empire. The best-known, because of the proliferation of sources available for studying it, is the dynasty founded by and descended from Ptolemy son of Lagos, which governed Egypt from 323 to 30 bc. The greatest of the dynasties, however, was that descended from Seleukos, a friend, colleague, and enemy of Ptolemy, which ruled varying territories of Asia from the Aegean Sea to the borders of India from 311 to 83 bc. The family of Antigonos I began the process of assuming royal titles and, after an erratic early career, came to rule Macedon from 277 to 168 bc, as the Antigonid dynasty. The least known and shortest lived of the four was the dynasty descended from Antipater, whose members ruled Macedon as regent and king from 334 to 294 bc. But the family also had a strong effect on all the other dynasties, and the daughters of the first of the family, Antipater, married into the other dynasties, with apparently a major effect on their histories, and above all on the treatment of royal wives.</p>
<p class="indent">This is a study of that dynasty, one which had been curiously neglected, for the other three have all had several full-length studies and biographies made of them, and this appears to be the first study of this dynasty.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_intro.vue?0867d043